import { SVGProps, Ref, forwardRef, memo } from 'react';
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={17} height={17} fill="none" ref={ref} {...props}>
    <g clipPath="url(#clip0_6144_6656)">
      <path
        d="M8.25028 15.3345C12.1952 15.3345 15.3931 12.1366 15.3931 8.19168C15.3931 4.24679 12.1952 1.04883 8.25028 1.04883C4.30539 1.04883 1.10742 4.24679 1.10742 8.19168C1.10742 12.1366 4.30539 15.3345 8.25028 15.3345Z"
        fill="white"
        stroke="#383838"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.25008 8.85381C9.63033 8.85381 10.7492 7.7349 10.7492 6.35465C10.7492 4.97438 9.63033 3.85547 8.25008 3.85547C6.86981 3.85547 5.7509 4.97438 5.7509 6.35465C5.7509 7.7349 6.86981 8.85381 8.25008 8.85381Z"
        stroke="#383838"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.4836 13.9447C11.2988 14.8178 9.83469 15.3338 8.25006 15.3338C6.66544 15.3338 5.20132 14.8178 4.0166 13.9447C4.25253 13.0561 4.76286 12.2621 5.47804 11.6775C6.26035 11.0381 7.23968 10.6888 8.25006 10.6888C9.26045 10.6888 10.2398 11.0381 11.0221 11.6775C11.7373 12.2621 12.2476 13.0561 12.4836 13.9447Z"
        stroke="#383838"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_6144_6656">
        <rect width="16" height="16" fill="white" transform="translate(0.25 0.191406)" />
      </clipPath>
    </defs>
  </svg>
);
const ForwardRef = forwardRef(SvgComponent);
const IconEmployee = memo(ForwardRef);
export default IconEmployee;
